module.exports = __webpack_public_path__ + "img/green_072.de6fe236.png";